<script>
	export let data;

	import {
		imageNotifyError,
		imageSize,
		currentEntityID,
		isNewDataChanged,
	} from '../../../../stores/variables';
	import { addNotify } from '../../../../scripts/notification';

	if (data) {
		data.imageID = 0;

		if (!data.newData) data.newData = [];

		if (data.newData) {
			if (data.newData['Image']) {
				data.imageSrc = data.newData['Image'];
				let url = data.newData['Image'].split('/');
				data.imageID = url[url.length - 1].split('.')[0];
			}
		}

		data.newData['Image'] = data.imageID;
	}

	function showImage(e) {
		$isNewDataChanged = true;
		data.image = Array.from(e.target.files)[0];
		let reader = new FileReader();
		reader.readAsDataURL(data.image);
		reader.onload = (e2) => {
			data.imageSrc = e2.target.result;
			data = data;
		};
	}
</script>

{#if data.name}
	<h3>{data.name}</h3>
{/if}

{#if data}
	<div class="image">
		<div class="image__wrap">
			<label class="form__upload-button" title={$imageNotifyError}>
				<input
					type="file"
					name={data.input_name + '_' + $currentEntityID}
					on:change={(e) => {
						if (e.target.files[0].size > $imageSize) {
							addNotify($imageNotifyError, 'error');
							e.target.value = '';
							data.newData[data.field_name] = 'deleted';
							data.imageSrc = false;
						} else {
							showImage(e);
						}
					}}
					accept=".png, .jpg, .jpeg"
				/>
				<span><i /></span>
				<div class="edit" class:active={data.imageSrc}>
					<i class="fas fa-pen  svelte-vchimp" />
				</div>
			</label>
			{#if data.imageSrc}
				<div style="background-image:url({data.imageSrc})" />
				<i
					class="far fa-trash-alt"
					on:click={() => {
						data.coverID = 0;
						data.newData['Image'] = 'deleted';
						data.imageSrc = false;
						$isNewDataChanged = true;
					}}
				/>
			{/if}
		</div>
	</div>
{/if}

{#if data.info}
	<p class="info">{data.info}</p>
{/if}

<style lang="scss">
	.info {
		margin: 10px 0;
		font-size: 14px;
		color: var(--text-gray-3);
	}
	.edit {
		display: none;
		position: absolute;
		top: 6px;
		left: 6px;
		align-items: center;
		justify-content: center;
		height: 32px;
		padding: 0 8px;
		cursor: pointer;
		color: var(--text-black-1);
		border-radius: 8px;
		background-color: var(--bg-main-1);
		z-index: -1;

		@media (max-width: 991px) {
			padding: 0;
			left: calc(6px + (12 - 6) * ((100vw - 360px) / (991 - 360)));
			top: calc(6px + (12 - 6) * ((100vw - 360px) / (991 - 360)));
			height: calc(20px + (32 - 20) * ((100vw - 360px) / (991 - 360)));
			width: calc(20px + (32 - 20) * ((100vw - 360px) / (991 - 360)));
		}

		&.active {
			z-index: 100;
			display: flex;
		}

		> i {
			margin: 0 !important;
			font-size: 16px;
			@media (max-width: 991px) {
				font-size: calc(
					10px + (16 - 10) * ((100vw - 360px) / (991 - 360))
				);
			}
		}
		> span {
			margin-left: 6px;
			font-weight: 500;
			white-space: nowrap;

			@media (max-width: 991px) {
				display: none;
			}
		}
	}
	.fa-trash-alt {
		position: absolute;
		top: 6px;
		right: 6px;
		height: 32px;
		width: 32px;
		background: var(--bg-main-1);
		z-index: 100;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 8px;
		cursor: pointer;
	}
	.image {
		&__wrap {
			display: flex;
			position: relative;
			height: 150px;
			width: 150px;
			border-radius: 20px;
			overflow: hidden;

			&::after {
				content: '';
				padding-top: 100%;
			}
			> label {
				position: absolute;
				top: 0;
				bottom: 0;
				left: 0;
				right: 0;
			}

			> div {
				position: relative;
				z-index: 10;
				display: flex;
				height: 100%;
				width: 100%;
				background: no-repeat center/cover;
			}
		}
	}
</style>
